var render = function render(){
  var _vm$feedData$network, _vm$feedData, _vm$feedData2, _vm$feedData$network2, _vm$feedData$token_im, _vm$feedData$apiValue, _vm$feedData$apiValue2, _vm$denominationMap$_, _vm$feedData$loaders, _vm$denominationMap$_2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-modal', {
    attrs: {
      "title": "Manual Price Feed Update",
      "size": "lg",
      "centered": "",
      "scrollable": "",
      "header-bg-variant": "light"
    },
    on: {
      "hidden": _vm.resetModal
    },
    model: {
      value: _vm.isModalVisible,
      callback: function callback($$v) {
        _vm.isModalVisible = $$v;
      },
      expression: "isModalVisible"
    }
  }, [_c('div', {
    staticClass: "update-feed-modal"
  }, [_c('div', {
    staticClass: "mb-4"
  }, [_c('MetaMaskConnector', {
    on: {
      "connected": _vm.handleMetaMaskConnected,
      "disconnected": _vm.handleMetaMaskDisconnected,
      "network-changed": _vm.handleNetworkChanged,
      "error": _vm.handleMetaMaskError
    }
  }), _vm.wrongNetworkSelection ? _c('b-alert', {
    staticClass: "mb-2",
    attrs: {
      "show": "",
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle mr-2"
  }), _vm._v(" You are connected to "), _c('strong', [_vm._v(_vm._s(_vm.currentNetworkName))]), _vm._v(" but this feed is on "), _c('strong', [_vm._v(_vm._s(((_vm$feedData$network = _vm.feedData.network) === null || _vm$feedData$network === void 0 ? void 0 : _vm$feedData$network.name) || "Unknown Network"))]), _vm._v(". Please switch your network in MetaMask. ")]) : _vm._e()], 1), _vm.feedData ? _c('div', {
    staticClass: "feed-info mb-4"
  }, [_c('strong', [_vm._v("By confirming this action, you will:")]), _c('div', {
    staticClass: "details"
  }, [_c('ul', [_c('li', [_vm._v("Submit the latest market price data to the blockchain")]), _c('li', [_vm._v(" Sign a transaction from your connected wallet via RedStone ")]), _c('li', [_vm._v("Pay gas fees (calculated by MetaMask)")])])]), _c('p', {
    staticClass: "note"
  }, [_vm._v(" This manual update ensures price accuracy and reliability in the oracle network. Your contribution maintains data integrity for all dependent DeFi protocols. ")]), _c('div', {
    staticClass: "feed-info-grid"
  }, [_c('div', {
    staticClass: "feed-info-item"
  }, [_c('span', {
    staticClass: "feed-info-label"
  }, [_vm._v("Network:")]), _c('span', {
    staticClass: "feed-info-value"
  }, [_vm.feedData ? _c('img', {
    staticClass: "feeds__token-image small",
    attrs: {
      "src": (_vm$feedData = _vm.feedData) === null || _vm$feedData === void 0 ? void 0 : _vm$feedData.network.image,
      "alt": (_vm$feedData2 = _vm.feedData) === null || _vm$feedData2 === void 0 ? void 0 : _vm$feedData2.network.name
    }
  }) : _vm._e(), _vm._v(" " + _vm._s((_vm$feedData$network2 = _vm.feedData.network) === null || _vm$feedData$network2 === void 0 ? void 0 : _vm$feedData$network2.name))])]), _c('div', {
    staticClass: "feed-info-item"
  }, [_c('span', {
    staticClass: "feed-info-label"
  }, [_vm._v("Contract Address:")]), _c('span', {
    staticClass: "feed-info-value"
  }, [_c('a', {
    staticClass: "feeds__contract-address",
    attrs: {
      "title": "Open address in ".concat(_vm.feedData.explorer.name, " explorer"),
      "target": "_blank",
      "href": "".concat(_vm.feedData.explorer.explorerUrl, "/address/").concat(_vm.feedData.contract_address)
    }
  }, [_vm._v(" " + _vm._s(_vm.truncateString(_vm.feedData.contract_address)) + " ")]), _c('CopyToClipboard', {
    attrs: {
      "copy-text": "Copy address",
      "value": _vm.feedData.contract_address
    }
  })], 1)]), _c('div', {
    staticClass: "feed-info-item"
  }, [_c('span', {
    staticClass: "feed-info-label"
  }, [_vm._v("Feed ID:")]), _c('span', {
    staticClass: "feed-info-value"
  }, [_c('img', {
    staticClass: "feeds__token-image",
    attrs: {
      "src": (_vm$feedData$token_im = _vm.feedData.token_image) === null || _vm$feedData$token_im === void 0 ? void 0 : _vm$feedData$token_im.logoURI,
      "alt": _vm.feedData.feed
    }
  }), _vm._v(" " + _vm._s(_vm.feedData.token))])]), _c('div', {
    staticClass: "feed-info-item"
  }, [_c('span', {
    staticClass: "feed-info-label"
  }, [_vm._v("Current Value:")]), (_vm$feedData$apiValue = _vm.feedData.apiValues) !== null && _vm$feedData$apiValue !== void 0 && _vm$feedData$apiValue.value ? _c('strong', {
    staticStyle: {
      "font-weight": "500"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.parseToCurrency((_vm$feedData$apiValue2 = _vm.feedData.apiValues) === null || _vm$feedData$apiValue2 === void 0 ? void 0 : _vm$feedData$apiValue2.value, (_vm$denominationMap$_ = _vm.denominationMap[_vm.feedData.token]) === null || _vm$denominationMap$_ === void 0 ? void 0 : _vm$denominationMap$_.denomination, _vm.feedData.feed))
    }
  }) : (_vm$feedData$loaders = _vm.feedData.loaders) !== null && _vm$feedData$loaders !== void 0 && _vm$feedData$loaders.feedDataValue ? _c('Loader', {
    staticClass: "feeds__loader"
  }) : _vm.feedData.answer ? _c('span', [_c('strong', {
    staticStyle: {
      "font-weight": "500"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.parseToCurrency(_vm.feedData.answer, (_vm$denominationMap$_2 = _vm.denominationMap[_vm.feedData.token]) === null || _vm$denominationMap$_2 === void 0 ? void 0 : _vm$denominationMap$_2.denomination, _vm.feedData.feed, true))
    }
  })]) : _c('span', {
    staticClass: "feeds__no-data"
  }, [_vm._v("no-data")])], 1)])]) : _vm._e(), _vm.transactionStatus ? _c('div', {
    staticClass: "transaction-status"
  }, [_c('b-alert', {
    staticClass: "mb-4",
    attrs: {
      "show": true,
      "variant": "light"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_vm.transactionStatus === 'pending' ? _c('div', {
    staticClass: "mr-3"
  }, [_c('b-spinner', {
    attrs: {
      "small": ""
    }
  })], 1) : _vm.transactionStatus === 'success' ? _c('div', {
    staticClass: "mr-3"
  }, [_c('i', {
    staticClass: "fa fa-check-circle text-success status-icon"
  })]) : _vm.transactionStatus === 'error' ? _c('div', {
    staticClass: "mr-3"
  }, [_c('i', {
    staticClass: "fa fa-times-circle text-danger status-icon"
  })]) : _vm._e(), _c('div', [_c('strong', [_vm._v(_vm._s(_vm.transactionStatusText))]), _vm.transactionHash ? _c('div', {
    staticClass: "mt-2"
  }, [_c('small', [_vm._v(" Transaction Hash: "), _c('a', {
    staticClass: "text-break",
    attrs: {
      "href": _vm.getTransactionExplorerUrl(_vm.transactionHash),
      "target": "_blank"
    }
  }, [_vm._v(" " + _vm._s(_vm.truncateString(_vm.transactionHash, 20)) + " ")]), _c('CopyToClipboard', {
    attrs: {
      "copy-text": "Copy tx hash",
      "value": _vm.transactionHash
    }
  })], 1)]) : _vm._e(), _vm.transactionError ? _c('div', {
    staticClass: "mt-2"
  }, [_c('small', [_vm._v(_vm._s(_vm.transactionError))])]) : _vm._e()])])])], 1) : _vm._e(), (!_vm.transactionStatus || _vm.transactionStatus === 'error') && _vm.feedData ? _c('div', {
    staticClass: "update-feed-form"
  }, [_c('b-form', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "title": _vm.updateButtonTooltip
    },
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.updateFeedWithRedstone.apply(null, arguments);
      }
    }
  }, [_c('b-button', {
    staticClass: "update-button",
    attrs: {
      "type": "submit",
      "pill": "",
      "variant": "outline-success",
      "disabled": !_vm.canUpdate,
      "block": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-sync-alt mr-2"
  }), _vm._v(" " + _vm._s(_vm.updateButtonText) + " ")])], 1)], 1) : _vm._e()])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }